import React from 'react';
import * as PropTypes from 'prop-types';
import { TextInput, StyleSheet } from 'react-native';
import FormField from './FormField';

const styles = StyleSheet.create({
    container: {
        width: '100%',
        height: 50,
        paddingHorizontal: 10,
        borderWidth: 1,

        borderRadius: 4,
        fontSize: 16,
    },
});

interface Props {
    placeholder: string;
    value: string;
    setFieldValue: any;
    setFieldTouched: any;
    multiline?: boolean;
    maxLength?: number;
    style?: object;
}

const Input: React.FC<Props> = ({
    placeholder,
    value,
    setFieldValue,
    setFieldTouched,
    multiline,
    maxLength,
    style,
}) => {
    return (
        <TextInput
            style={style}
            placeholder={placeholder}
            placeholderTextColor="#8e8e8e"
            autoCapitalize="none"
            onChangeText={setFieldValue}
            onBlur={() => setFieldTouched(true)}
            value={value}
            multiline={multiline}
            maxLength={maxLength}
        />
    );
};

Input.defaultProps = {
    placeholder: '',
    value: '',
    style: styles.container,
    maxLength: 100,
    multiline: false,
};

Input.propTypes = {
    placeholder: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    setFieldValue: PropTypes.func.isRequired,
    setFieldTouched: PropTypes.func.isRequired,
    maxLength: PropTypes.number,
    style: PropTypes.object,
};

export default FormField(Input);
